<template>
    <b-modal
        :title="$t(id ? 'update_product_story' : 'create_product_story')"
        :visible="value"
        @close="$emit('input', false)"
        @shown="loadEditor"
        :id="'modal-edit-product-story-' + id"
        size="lg"
        no-close-on-backdrop
        :ok-title="$t('save')"
        @ok="save"
        :ok-disabled="saving"
        @cancel="$emit('input', false)"
    >
        <loading-spinner class="loading-spinner" v-if="loading" />
        <b-form v-else @submit="save" :disabled="saving" id="myForm">
            <b-form-group
                id="fieldset-title"
                label="Title"
                label-for="input-1"
                :invalid-feedback="errors['title']"
                :state="getFieldState('title')"
            >
                <b-form-input
                    required
                    :state="getFieldState('title')"
                    v-model="title"
                    placeholder="Title"
                ></b-form-input>
            </b-form-group>
            <div
                v-for="(input, index) in text_inputs"
                :key="`input.text-input-${index + 1}`"
            >
                <b-form-group
                    id="fieldset-text"
                    :label="'Content'"
                    label-for="input.text-input"
                    :invalid-feedback="errors['text']"
                    :state="getFieldState(input['text-input'])"
                >
                    <b-form-textarea
                        required
                        rows="7"
                        :state="getFieldState(input['text-input'])"
                        v-model="input['text-input']"
                        :placeholder="'Text'"
                    ></b-form-textarea>
                </b-form-group>
            </div>
            <button
                class="btn btn-secondary mb-2 add"
                v-if="text_inputs.length > 1"
                @click="removeField()"
            >
                Remove
            </button>
            <b-form-group
                id="fieldset-position"
                label="Position"
                label-for="input-1"
                :invalid-feedback="errors['position']"
                :state="getFieldState('position')"
            >
                <b-form-input
                    required
                    :state="getFieldState('position')"
                    v-model="position"
                    type="number"
                    :placeholder="'0'"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                id="fieldset-variants"
                label="Variant"
                label-class="text-capitalize"
            >
                <b-select v-model="selectedVariantId">
                    <b-select-option :value="undefined"
                        >{{ $t("please_select") }}
                    </b-select-option>
                    <b-select-option
                        v-for="variant in variants"
                        :key="variant.id"
                        :value="variant.id"
                        >{{ variant.reference }}
                    </b-select-option>
                </b-select>
            </b-form-group>
        </b-form>
        <div v-if="!loading && id" class="mt-3">
            <h5>{{ $t("attached_files") }}</h5>
            <file-manager
                title=""
                resource-type="product-story"
                :resource-id="id"
            ></file-manager>
        </div>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button
                v-if="id != 0"
                variant="danger"
                class="modal-delete-button"
                @click="deleteProductStory"
            >
                {{ $t("delete") }}
            </b-button>
            <b-button variant="secondary" @click="cancel()">
                {{ $t("cancel") }}
            </b-button>
            <b-button variant="primary" @click="ok">
                {{ $t("save") }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import FileManager from "../../Common/FileManager";
import LoadingSpinner from "../../Common/LoadingSpinner";

export default {
  name: "ProdyctStoryDialog",
  components: { FileManager, LoadingSpinner },
  props: {
    id: Number,
    value: Boolean,
    base_product_id: Number,
    collection_id: Number
  },
  data() {
    return {
      selectedVariantId: undefined,
      base_product: null,
      text_inputs: [{ "text-input": "" }],
      variants: [],
      title: "",
      text: "",
      position: 1,
      errors: {},
      saving: false,
      loading: true
    };
  },
  mounted() {},
  methods: {
    getFieldState(field) {
      return this.errors[field] === undefined ? null : false;
    },
    getBaseProduct() {
      axios.get(`/api/products/${this.base_product_id}`).then(r => {
        this.base_product = r.data.data;
        this.loading = false;
      });
    },
    addField() {
      var obj = {};
      obj["text-input"] = "";
      this.text_inputs.push(obj);
    },
    removeField() {
      this.text_inputs.pop();
    },
    save(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.saving = true;
      this.errors = {};

      let rp = this.id ? this.update() : this.create();
      rp.then(r => {
        this.$emit("input", false);
        this.$emit("saved", true);
      })
        .catch(err => {
          for (let [key, value] of Object.entries(err.response.data.errors)) {
            this.$set(this.errors, key, value[0]);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
    create() {
      return axios.post(
        `/api/collections/${this.collection_id}/products/${
          this.base_product_id
        }/stories`,
        this.getData()
      );
    },
    update() {
      return axios.put(
        `/api/collections/${this.collection_id}/products/${
          this.base_product_id
        }/stories/${this.id}`,
        this.getData()
      );
    },
    deleteProductStory() {
      axios
        .delete(
          `/api/collections/${this.collection_id}/products/${
            this.base_product_id
          }/stories/${this.id}`
        )
        .then(response => {
          if (response.status === 204) {
            this.$root.$emit("page-deleted", this.id);
            this.$root.$emit(
              "bv::hide::modal",
              "modal-edit-product-story-" + this.id
            );
            return;
          } else {
            this.$bvToast.toast(this.$t("delete_error"), {
              title: this.$t("delete_product_story_error"),
              toaster: "b-toaster-top-right",
              autoHideDelay: 5000,
              appendToast: true,
              solid: true,
              variant: "danger"
            });
          }
        });
    },
    getData() {
      return {
        title: this.title,
        text_inputs: this.text_inputs,
        position: this.position,
        variant_id: this.selectedVariantId
      };
    },
    loadEditor() {
      this.errors = {};
      this.getBaseProduct();
      this.loadProductVariant();
      if (this.id) {
        this.loadProductStories();
      }
      let modalContentElements = document.getElementsByClassName(
        "modal-content"
      );
      // document
      //     .getElementById(modalContentElements[0].id)
      //     .removeAttribute("tabindex");
    },
    loadProductStories() {
      axios.get(`/api/product-stories/${this.id}`).then(r => {
        let data = r.data.data;
        let texts = data.text.split("<br>");
        var input_texts = [];
        texts.forEach((item, index) => {
          var text = { "text-input": item };
          input_texts.push(text);
        });
        this.title = data.title;
        this.text_inputs = input_texts;
        this.position = data.position;
        this.selectedVariantId = data.variant_id;
      });
    },
    loadProductVariant() {
      axios.get(`/api/products/${this.base_product_id}/variants`).then(r => {
        this.variants = r.data.data;
      });
    }
  }
};
</script>

<style scoped>
</style>
